import EventEmitter2 from 'eventemitter2';
import IAppLogger from './IAppLogger';
import IAppManager from './IAppManager';

class AppEvents {
  private _emitter: EventEmitter2 = new EventEmitter2();
  private _events: string[] = [];
  private _enabled: boolean = false;
  private _logger: IAppLogger;

  constructor(appManager: IAppManager) {
    this._logger = appManager.logger('app', 'info');
    this.registerEvent('error');
  }

  public on<T>(event: string, listener: (arg: T) => void): void;
  public on(event: string, listener: (...args: any[]) => void): void {
    if (!this._events.includes(event)) {
      throw new Error(`Event ${event} is not registered`);
    }
    this._emitter.on(event, listener);
  }

  public onAny(
    listener: (event: string | string[], ...args: any[]) => void,
  ): void {
    this._emitter.onAny(listener);
  }

  public off(event: string, listener: (...args: any[]) => void): void {
    if (!this._events.includes(event)) {
      throw new Error(`Event ${event} is not registered`);
    }
    this._emitter.off(event, listener);
  }

  public emit(event: string): void;
  public emit<T>(event: string, arg: T): void;
  public emit(event: string, ...args: any[]): void {
    if (!this._enabled) {
      this._logger.warn(`Event ${event} emitted before enabled`);
      return;
    } else if (!this._events.includes(event)) {
      throw new Error(`Event ${event} is not registered`);
    }

    // emit event
    // make sure we don't bubble errors up to caller
    try {
      this._emitter.emit(event, ...args);
    } catch (err) {
      this._logger.error(
        `Event listener threw an exception for event '${event}'`,
        err,
      );
    }
  }

  public registerEvent(event: string): void {
    this._events.push(event);
  }

  public enable(): void {
    this._enabled = true;
  }
}

export default AppEvents;
